import shareConstants    from './share.constants';
import shareInitialState from './share.state';

function shareReducer(state = shareInitialState, action) {
  switch (action.type) {
    case shareConstants.SHOW_MODAL:
      state = {
        ...state,
        open:    true,
        loading: true,
      };
      break;

    case shareConstants.HIDE_MODAL:
      state = { ...shareInitialState };
      break;

    case shareConstants.ADD_LINK:
      state = {
        ...state,
        link: action.payload,
      };
      break;

    case shareConstants.LOADING_SUCCESS:
      state = {
        ...state,
        loading: false,
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default shareReducer;
